export default "__VITE_ASSET__DQ20lTFW__"